export class orderDB {
    static list_order = [
        {
            "order id": "#51240",
            "product": "<img src='assets/images/electronics/product/25.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/13.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/16.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-secondary'>Cash On Delivery</span>",
            "paymeny method": "Paypal",
            "order status": "<span class='badge badge-success'>Delivered</span>",
            "date": "Dec 10,18",
            "total": "$54671"
        },
        {
            "order id": "#51241",
            "product": "<img src='assets/images/electronics/product/12.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/3.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Master Card",
            "order status": "<span class='badge badge-primary'>Shipped</span>",
            "date": "Feb 15,18",
            "total": "$2136"
        },
        {
            "order id": "#51242",
            "product": "<img src='assets/images/electronics/product/14.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-warning'>Awaiting Authentication</span>",
            "paymeny method": "Debit Card",
            "order status": "<span class='badge badge-warning'>Processing</span>",
            "date": "Mar 27,18",
            "total": "$8791"
        },
        {
            "order id": "#51243",
            "product": "<img src='assets/images/electronics/product/6.jpg' class='img-30 mr-2'><img src='assets/images/furniture/8.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-danger'>Payment Failed</span>",
            "paymeny method": "Debit Card",
            "order status": "<span class='badge badge-danger'>Cancelled</span>",
            "date": "Sep 1,18",
            "total": "$139"
        },
        {
            "order id": "#51244",
            "product": "<img src='assets/images/jewellery/pro/18.jpg' class='img-30 mr-2'><img src='assets/images/fashion/pro/06.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Paypal",
            "order status": "<span class='badge badge-primary'>Shipped</span>",
            "date": "Sep 1,18",
            "total": "$139"
        },
        {
            "order id": "#51245",
            "product": "<img src='assets/images/electronics/product/19.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/20.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/23.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Visa",
            "order status": "<span class='badge badge-success'>Delivered</span>",
            "date": "Jan 14,18",
            "total": "$6791"
        },
        {
            "order id": "#51246",
            "product": "<img src='assets/images/electronics/product/24.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-warning'>Awaiting Authentication</span>",
            "paymeny method": "Credit Card",
            "order status": "<span class='badge badge-warning'>Processing</span>",
            "date": "Apr 22,18",
            "total": "$976"
        },
        {
            "order id": "#51247",
            "product": "<img src='assets/images/electronics/product/21.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/8.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-danger'>Payment Failed</span>",
            "paymeny method": "Master Card",
            "order status": "<span class='badge badge-danger'>Cancelled</span>",
            "date": "Mar 26,18",
            "total": "$3212"
        },
        {
            "order id": "#51248",
            "product": "<img src='assets/images/electronics/product/18.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/8.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Paypal",
            "order status": "<span class='badge badge-primary'>Shipped</span>",
            "date": "Feb 29,18",
            "total": "$6791"
        },
        {
            "order id": "#51249",
            "product": "<img src='assets/images/electronics/product/17.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Master Card",
            "order status": "<span class='badge badge-secondary'>Processing</span>",
            "date": "Sep 2,18",
            "total": "$9765"
        },
        {
            "order id": "#51250",
            "product": "<img src='assets/images/electronics/product/7.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/4.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Credit Card",
            "order status": "<span class='badge badge-primary'>Shipped</span>",
            "date": "Dec 10,18",
            "total": "$9705"
        },
        {
            "order id": "#51251",
            "product": "<img src='assets/images/electronics/product/22.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/20.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-secondary'>Cash On Delivery</span>",
            "paymeny method": "Paypal",
            "order status": "<span class='badge badge-primary'>Shipped</span>",
            "date": "Feb 15,18",
            "total": "$1500"
        },
        {
            "order id": "#51252",
            "product": "<img src='assets/images/electronics/product/3.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-danger'>Payment Failed</span>",
            "paymeny method": "Credit Card",
            "order status": "<span class='badge badge-danger'>Cancelled</span>",
            "date": "Mar 27,18",
            "total": "$18.97"
        },
        {
            "order id": "#51253",
            "product": "<img src='assets/images/flower/blog/insta/8.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Master Card",
            "order status": "<span class='badge badge-success'>Delivered</span>",
            "date": "Dec 17,18",
            "total": "$19.47"
        },
        {
            "order id": "#51254",
            "product": "<img src='assets/images/electronics/product/11.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/2.jpg' class='img-30 mr-2'><img src='assets/images/electronics/product/9.jpg' class='img-30'>",
            "payment status": "<span class='badge badge-success'>Paid</span>",
            "paymeny method": "Master Card",
            "order status": "<span class='badge badge-primary'>Shipped</span>",
            "date": "Nov 29,18",
            "total": "$7.48"
        },
    ]
}
